import React, {useEffect} from 'react'
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function WhatAreSnapVideo() {
    useEffect(() => {
        Fancybox.bind('[data-fancybox="single"]', {
                    groupAttr: false,
                  });
    
        return () => {
          Fancybox.destroy(); // Cleanup Fancybox when component unmounts
        };
      }, []);
    return (
        <>
            <section className="what-are-snap-video" id="what-are-snap-video">
                <div className="row ">
                    <div className="container">
                        <div className="what-are-snap-video-wrap wow zoomIn">
                            <div className="top-content">
                                <div className="title">
                                    <h2>What are <span className="red">Snapshot Videos</span></h2>
                                </div>

                                <p>Capture attention and keep your members informed with Snapshot Videos - 90 second updates that engage your audience and showcase the latest happenings within your Association</p>
                            </div>
                            <div className="example-content">
                                <h3>Example Videos</h3>
                            </div>
                            <div className="popup-content">
                                <div className="popup-wrap">
                                    <div className="popup-box wow zoomIn example-video-box">
                                        <div className="popup-image">
                                            {/* <a data-fancybox="single" href="images/pop-up-video2.mp4" className="popup popup-btn"></a> */}
                                            <a data-fancybox="single" href="https://vimeo.com/1085788599" className="popup popup-btn"></a>
                                            <img src="./images/nann-main.png" />
                                        </div>
                                        {/* <div className="popup-text">
                                            <h3>Consectetuer Adipiscing Elit</h3>
                                        </div> */}
                                    </div>

                                    <div className="popup-box wow fadeInLeft example-video-box">
                                        <div className="popup-image">
                                            {/* <a data-fancybox="single" href="images/pop-up-video1.mp4" className="popup popup-btn"></a> */}
                                            <a data-fancybox="single" href="https://vimeo.com/1085754386" className="popup popup-btn"></a>
                                            <img src="./images/aasl-main.png" />
                                        </div>
                                        {/* <div className="popup-text">
                                            <h3>Lorem ipsum dolor sit amet</h3>
                                        </div> */}
                                    </div>
                                    
                                    <div className="popup-box wow fadeInRight example-video-box">
                                        <div className="popup-image">
                                            {/* <a data-fancybox="single" href="images/pop-up-video3.mp4" className="popup popup-btn"></a> */}
                                            <a data-fancybox="single" href="https://vimeo.com/1080643342" className="popup popup-btn"></a>
                                            <img src="./images/asc.png" />
                                        </div>
                                        {/* <div className="popup-text">
                                            <h3>Nonummy Nibh Euismod</h3>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
